import { makeStyles } from "@material-ui/core/styles"
import { DrawerWidth, DrawerWidthClose } from "../constants/DRAWER"

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: "flex",
    width: "100%",
    height: "100vh",
    maxHeight: "100vh",
    minHeight: 0,
    overflow: "hidden",
    backgroundColor: theme.palette.background100,
    "& .MuiButton-outlinedPrimary": {
      color: theme.mode === "light" ? "#FFF" : "#FFF",
      backgroundColor: theme.mode === "light" ? theme.palette.primary200 : "#1c1c1c",
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: theme.mode === "light" ? "Primary" : "#FFF",
    },
    "& .MuiIconButton-root": {
      color: "theme.palette.light",
    },
    "@supports (height: 100dvh)": {
      height: "100dvh",
      maxHeight: "100dvh",
    },
  }),
  avatar: {
    width: "100%",
  },
  filterButtonActive: {
    color: theme.palette.primary200,
  },
  toolbar: {
    paddingRight: 24,
    color: theme.palette.dark,
    backgroundColor: theme.palette.background100,
    minHeight: "88px",
    display: "flex",
    padding: theme.spacing(2),
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    position: "relative",
    "@media(max-width: 960px)": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "@media(max-width: 550px)": {
      minHeight: "72px",
      padding: "8px 12px",
    },
  },
  toolbarIcon: {
    marginLeft: "-8px",
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
    backgroundClip: "padding-box",
    display: "flex",
    minHeight: "60px",
    width: "100%",
    height: "88px",
    padding: "15px 15px",
    alignItems: "center",
    backgroundColor: theme.palette.background200,
  },
  iconBox: {
    zIndex: theme.zIndex.drawer + 1,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flex: "1 0 0",
  },
  logoImage: {
    minWidth: "133.645px",
    transition: "opacity 0.25s ease",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "none",
    justifyContent: "space-between",
    display: "flex",
    "@media(max-width: 960px)": {
      borderBottom: `1px solid ${theme.palette.borderColorMenu}`,
    },
    "@media(min-width: 960px)": {
      width: `calc(100% - ${DrawerWidthClose}px)`,
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: DrawerWidth,
    width: `calc(100% - ${DrawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  menuButton: {
    marginRight: 12,
    "@media(min-width: 960px)": {
      display: "none",
    },
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: theme.palette.elementBar,
  },
  textWelcome: {
    "@media (max-width: 550px)": {
      display: "none",
    },
  },
  drawerPaper: {
    whiteSpace: "nowrap",
    backgroundColor: theme.palette.background200,
    width: DrawerWidth,
    display: "flex",
    flexDirection: "column",
    alignItems: "flexStart",
    overflowY: "scroll",
    overflowX: "hidden",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    border: "none",
    boxShadow: "none",
  },
  drawerPaperClose: {
    alignItems: "flexStart",
    overflowY: "scroll",
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up("sm")]: {
      width: DrawerWidthClose,
    },
    [theme.breakpoints.down("sm")]: {
      width: DrawerWidthClose, // manter colapsado com ícones também no mobile
    },
    border: "none",
    boxShadow: "none",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
  },
  appBarSpacer: {
    minHeight: "88px",
  },
  content: {
    flex: "1 1 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflow: "auto",
    paddingTop: "89px",
    minHeight: 0,
  },
  contentMobile: {
    flex: "1 1 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 0,
    overflow: "hidden",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  logo: {
    logo: theme.logo,
  },
  logoDark: {
    logoDark: theme.logoDark,
  },
  menuPerfil: {
    display: "flex",
    padding: theme.spacing(2),
    alignItems: "center",
    gap: theme.spacing(1),
    alignSelf: "stretch",
    background: theme.palette.background100,
    borderBottom: `1px solid ${theme.palette.neutral200}`,
    zIndex: 1,
  },
  menuPerfilPaper: {
    background: theme.palette.background100,
    width: "300px",
    height: "284px",
    overflow: "visible",
    borderRadius: "12px",
    marginTop: "2px",
    zIndex: 1,
  },
  textMenuPerfil: {
    color: theme.palette.neutral400,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: `Roboto`,
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
    paddingLeft: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
    zIndex: 1,
  },
  menu: {
    padding: "16px 8px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    background: theme.palette.background100,
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.2)",
    zIndex: 1,
  },
  textRoute: {
    color: theme.palette.neutral400,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "125%",
    letterSpacing: "-0.05px",
    "@media(max-width: 960px)": {
      display: "none",
    },
  },
  circleMenuPerfil: {
    display: "flex",
    width: "56px",
    height: "56px",
    padding: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "100px",
    border: `1px solid ${theme.palette.neutral200}`,
    backgroundColor: `${theme.palette.background200}`,
    color: " #009FFD",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
  },
  circleMenuPerfilAppBar: {
    display: "flex",
    width: "56px",
    height: "56px",
    padding: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "100px",
    backgroundColor: `${theme.palette.background200}`,
    color: `${theme.palette.primary200}`,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
  },
  UserName: {
    color: `${theme.palette.neutral400}`,

    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
  },
  CompanyName: {
    color: `${theme.palette.neutral400}`,

    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
    marginTop: "-13px",
  },
  iconMenu: {
    color: theme.palette.neutral400,
  },
  elementBar: {
    display: "flex",
    padding: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
  },
  elementBarCircle: {
    display: "flex",
    marginLeft: "16px",
    marginRight: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    padding: 0,
    "@media (max-width: 550px)": {
      marginLeft: "8px",
      marginRight: 0,
      minWidth: 44,
      minHeight: 44,
    },
  },
  button: {
    color: theme.palette.buttonColor,
    backgroundColor: theme.palette.buttonBackground,
    borderRadius: "12px",
    fontWeight: 500,
    lineHeight: "24px",
    textTransform: "none",
  },
  menuAparenciaRoot: {
    zIndex: `${theme.zIndex.modal + 20} !important`,
  },
  menuAparencia: {
    backgroundColor: theme.palette.background100,
    width: "300px",
    height: "200px",
    overflow: "visible",
    borderRadius: "12px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.2)",
    marginLeft: "-328px",
    marginTop: "104px",
    zIndex: `${theme.zIndex.modal + 21} !important`,
    "@media (max-width: 550px)": {
      width: "calc(100vw - 32px)",
      maxWidth: "300px",
      height: "auto",
      marginLeft: 0,
      marginTop: theme.spacing(1),
      overflow: "hidden",
    },
  },
  menuAparenciaItens: {
    padding: "8px 8px 16px 8px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    background: `${theme.palette.menuAparenciaBackground}`,
    borderRadius: "12px",
    zIndex: `${theme.zIndex.modal + 22} !important`,
  },
  buttonNova: {
    color: theme.palette.neutral100,
    backgroundColor: theme.palette.primary200,
    borderRadius: "12px",
    fontWeight: 500,
    lineHeight: "24px",
    textTransform: "none",
    marginLeft: "8px",
  },
  button: {
    width: "100%",
    justifyContent: "flex-start",
    padding: theme.spacing(2),
    textTransform: "none",
    color: `${theme.palette.elementBar}`,
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "125%",
    letterSpacing: "-0.04px",
    borderRadius: "12px",
  },
  filterButton: {
    marginLeft: theme.spacing(2),
    borderRadius: theme.radius.radius300,
    padding: 8,
    color: theme.palette.neutral400,
  },
  popover: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
  },
  buttonPopover: {
    width: "190px",
    borderRadius: theme.radius.radius300,
    padding: theme.spacing(2),
    color: theme.palette.neutral400,
    justifyContent: "space-between",
  },
  paperPopover: {
    "& .MuiPaper-rounded": {
      borderRadius: "12px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "20px",
    minWidth: "416px",
    [theme.breakpoints.down(530)]: {},
    "@media (max-width: 1250px)": {
      minWidth: "0px",
      padding: "0px",
    },
  },
  search: {
    "@media (max-width: 1250px)": {
      with: "0px",
      height: "0px",
      visibility: "hidden",
    },
  },
}))

export default useStyles
